module.exports = __webpack_public_path__ + "static/Frame12-b9571620687204f2aa4e8fe94a179399.png";